import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import Meeting from "containers/pages/CANmeet/Meeting";

function MeetingPage() {

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        height: "90vh",
      }}
    >
      <Meeting />
    </Box>
  );
}

export default MeetingPage;
